// extracted by mini-css-extract-plugin
module.exports = {"list":"Menu_list__2NFYX"};